import { Component, HostBinding, Input, OnChanges, SimpleChanges, forwardRef } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

import { DecimalPipe } from '@angular/common';

@Component({
    selector: 'app-amount-input',
    templateUrl: './amount-input.component.html',
    styleUrls: ['./amount-input.component.scss'],
    providers: [{
        provide: NG_VALUE_ACCESSOR,
        useExisting: forwardRef(() => AmountInputComponent),
        multi: true
    }]
})

export class AmountInputComponent implements ControlValueAccessor, OnChanges {


    @Input()
    public placeholder: string;

    @Input()
    public showValidation: boolean;

    @Input()
    public incrementViaMouseWheel = true;
    @Input()
    public isError: boolean;
    @Input()
    public disabled: boolean;

    @Input()
    public showIcon = true;

    @Input()
    public name: string;

    @Input()
    public step = 1;

    @HostBinding('class.force-form-validation-visibility')
    @Input()
    forceFormValidationVisibility = false;

    @Input()
    public minNumber: number;

    @Input()
    public maxNumber: number;

    public textValue: string;

    private regex: RegExp = /[^\d-]/;
    private multipler = 1;

    public propagateChange: (_: any) => void = (_: any) => {
    }
    public onTouchedFn: () => void = () => {
    }

    public registerOnChange(fn: any): void {
        this.propagateChange = fn;
    }

    public registerOnTouched(fn: any): void {
        this.onTouchedFn = fn;
    }

    setDisabledState(isDisabled: boolean): void {
        this.disabled = isDisabled;
    }


    public writeValue(value: number): void {
        this.textValue = value || value === 0 ? value.toString() : '';
    }

    private toFixedNumber(value: string): number {
        const valueNumber = +this.textValue.replace(',', '.');
        return Math.floor(valueNumber * this.multipler) / this.multipler;
    }


    /*
    * returns textValue only if is inside min and max range, otherwise returns one of range numbers
    * */
    private toRangeNumber(value: number) {
        if (!isNaN(+this.minNumber) && this.minNumber > value) {
            return +this.minNumber;
        }
        if (!isNaN(+this.maxNumber) && this.maxNumber < value) {
            return +this.maxNumber;
        }
        return value;
    }


    public updateChanges(inputElement: HTMLInputElement): void {
        this.formatInput(inputElement);
        const outputNumber =
            this.textValue !== null && this.textValue !== '' && this.textValue !== '-' ? this.toFixedNumber(this.textValue) : null;
        // console.log('outputNumber', outputNumber);
        this.propagateChange(outputNumber);
    }


    public onIconClicked() {

    }


    private formatInput(inputElement: HTMLInputElement): void {

        if (this.textValue === '-' && !isNaN(this.minNumber) && this.minNumber >= 0) {
            this.textValue = '';
            inputElement.value = this.textValue;
        }

        if (this.textValue !== '' && this.textValue !== '-') {

            this.textValue = this.textValue.replace(/\./g, ',');

            while (this.textValue.match(/,,/)) {
                this.textValue = this.textValue.replace(/,,/g, ',');
            }

            while (this.textValue.match(/,.+,/)) {
                this.textValue = this.textValue.slice(0, this.textValue.lastIndexOf(','));
            }

            while (this.textValue.match(/--/)) {
                this.textValue = this.textValue.replace(/--/g, '-');
            }

            while (this.textValue.match(/.-/)) {
                this.textValue = this.textValue.slice(0, this.textValue.lastIndexOf('-'));
            }

            if (this.textValue.match(this.regex)) {
                this.textValue = this.textValue.replace(new RegExp(this.regex, 'g'), '');
            }

            inputElement.value = this.textValue !== '-' ? this.toFixedNumber(this.textValue).toString() : this.textValue;
        }

    }


    /**
     * increases/decreases input value by the step value
     * @param {number} direction  - (!!! this is not increment value !!!) if direction is positive number,
     * then input value will be increased by the'step' value, otherwise will be decreased
     */
    public incrementValue(direction: number) {

        let valueNumber = this.toFixedNumber(this.textValue) * this.multipler;
        valueNumber = Math.floor(valueNumber);
        if (direction < 0) {
            valueNumber -= this.step * this.multipler;
        } else {
            valueNumber += this.step * this.multipler;
        }
        this.textValue = (this.toRangeNumber(valueNumber / this.multipler)).toString();
    }

    public onBlur() {
        this.onTouchedFn();
    }

    public ngOnChanges(changes: SimpleChanges): void {
        if (changes.hasOwnProperty('step')) {
            this.multipler = 1;
            while ((this.multipler * this.step) !== Math.floor(this.multipler * this.step)) {
                this.multipler *= 10;
            }

            if (this.multipler > 1) {
                this.regex = /[^\d-,]/;
            } else {
                this.regex = /[^\d-]/;
            }
        }
    }


    mousewheel($event: WheelEvent) {
        if (this.disabled || !this.incrementViaMouseWheel) {
            return;
        }
        $event.preventDefault();
        this.incrementValue(-$event.deltaY);
        this.updateChanges($event.target as HTMLInputElement);
    }

    onKeyDown($event: KeyboardEvent) {
        if (this.disabled) {
            return;
        }
        if ($event.key === 'ArrowUp') {
            $event.preventDefault();
            this.incrementValue(1);
        }
        if ($event.key === 'ArrowDown') {
            $event.stopPropagation();
            this.incrementValue(-1);
        }
        this.updateChanges($event.target as HTMLInputElement);
    }


}
